import React from 'react';
import { motion } from 'framer-motion';
import {
  Sparkle
} from '@phosphor-icons/react';

const EmptyState = ({ 
  icon: Icon = Sparkle, 
  title, 
  description, 
  buttonText, 
  onButtonClick,
  gradient = 'from-[#6366F1] to-[#8B5CF6]'
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex flex-col items-center justify-center py-16 px-6 text-center"
    >
      {/* Icon */}
      <div className={`mb-6 w-20 h-20 rounded-2xl bg-gradient-to-br ${gradient} flex items-center justify-center`}>
        <Icon size={40} className="text-white" />
      </div>

      {/* Title */}
      <h3 className="text-2xl font-bold text-white mb-3">
        {title}
      </h3>

      {/* Description */}
      <p className="text-[#A0AEC0] text-lg max-w-md mb-8">
        {description}
      </p>

      {/* Action Button */}
      {buttonText && onButtonClick && (
        <button
          onClick={onButtonClick}
          className="relative overflow-hidden rounded-full group"
        >
          <div className={`absolute inset-0 bg-gradient-to-r ${gradient}`}></div>
          <span className="relative z-10 flex items-center gap-2 px-8 py-4 text-white font-semibold">
            {buttonText}
          </span>
        </button>
      )}
    </motion.div>
  );
};

export default EmptyState;